import { defineComponent } from "vue";
import seasonStore from "../store/seasonStore";
export default defineComponent({
    setup: function () {
        return seasonStore();
    },
});
